import { useEffect, useState, useContext } from "react";
import { baseUrl } from "../../connections";
import { UserContext } from "../../context/UserContext";
import { appendAuthToken } from "../../utils/authSession";

export const useBrand = () => {
  const { userDetails } = useContext(UserContext);
  const [isBrandLoading, setIsLoading] = useState(true);
  const [brandError, setError] = useState(false);
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [payload, setBrandPayload] = useState(null);
  const [brandpayload1, setBrandPayload1] = useState(null);
  const [updateBrandFav, setUpdateBrandFav] = useState();
  const [reccurLoad, setBrandReccurLoad] = useState(true);

  const onBrandLoad = () => {
    if (!payload) return;
    setIsLoading(true);
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("x-auth-token", userDetails?.token);

    const params = JSON.stringify(payload);

    const requestOptions = {
      method: "GET",
      headers: headers,
      redirect: "follow",
    };

    fetch(`${baseUrl}/user/brand/list?${payload}`, requestOptions)
      .then(async (response) => {
        const res = await response.text();
        if (response.status !== 200) {
          throw res;
        }
        return JSON.parse(res);
      })
      .then((result) => {
        setData([...result.data]);
        setCount(result?.count);
        setError(false);
        setIsLoading(false);
      })
      .catch((err) => {
        setError(err);
        setIsLoading(false);
      });
  };

  // useEffect(() => {
  //   if (payload) {
  //     onBrandLoad();
  //   }
  //   const interval = setInterval(() => onBrandLoad(), 180000)
  //   return () => {
  //     clearInterval(interval);
  //   }
  // }, [payload, brandpayload1]);
  useEffect(() => {
    let interval;
    if (reccurLoad && payload && payload !== null) {
      onBrandLoad();
    }
    if (
      reccurLoad &&
      payload &&
      payload !== null &&
      JSON.stringify(payload) !== "null"
    ) {
      interval = setInterval(() => onBrandLoad(), 180000);
    } else {
      // Clear the interval when reccurLoad is false
      clearInterval(interval);
    }

    return () => {
      // Cleanup to avoid memory leaks
      clearInterval(interval);
    };
  }, [payload, reccurLoad]);

  useEffect(() => {
    if (updateBrandFav) {
      // setIsLoading(true);

      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      appendAuthToken(headers, userDetails?.token);

      const params = JSON.stringify(updateBrandFav);

      const requestOptions = {
        method: "POST",
        headers: headers,
        body: params,
        redirect: "follow",
      };

      fetch(`${baseUrl}/favourite`, requestOptions)
        .then(async (response) => {
          const res = await response.text();
          if (response.status !== 200) {
            throw res;
          }
          return JSON.parse(res);
        })
        .then((result) => {
          onBrandLoad();
          setError(false);
          setIsLoading(false);
        })
        .catch((err) => {
          setError(err);
          setIsLoading(false);
        });
    }
  }, [updateBrandFav]);

  return {
    barndList: data,
    brandCount: count,
    isBrandLoading,
    brandError,
    setBrandPayload,
    setUpdateBrandFav,
    setBrandPayload1,
    brandpayload1,
    setBrandReccurLoad,
  };
};
